import { combineReducers } from 'redux';
import { GET_CLASSLINK_SETTINGS, SAVE_CLASSLINK_SETTINGS, CLASSLINK_STATE_CHANGED } from './Integrations.actions';
import { ASYNC_FINISH } from '../../../common';

// district/integrations/classlink config, as returned by the callables. null = not loaded.
const classlinkConfig = (state = null, action) => {
  switch (action.type) {
    case ASYNC_FINISH:
      if (action.model === GET_CLASSLINK_SETTINGS || action.model === SAVE_CLASSLINK_SETTINGS) {
        return (action.data && action.data.config) || {};
      }
      return state;
    default:
      return state;
  }
};

// Live integrations/classlink node (status, runs, pending) from the RTDB listener.
const classlinkState = (state = null, action) => {
  if (action.type === CLASSLINK_STATE_CHANGED) {
    return action.state || {};
  }
  return state;
};

export const _reducer = combineReducers({
  classlinkConfig,
  classlinkState,
});

export default 'Integrations.reducers.js';
